<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="primaryText--text mt-4 mb-12">Please upload a copy of your CV/Resume</div>

        <v-file-input
          v-if="!cvFileId"
          prepend-icon="mdi-file-upload-outline"
          accept="application/pdf, application/msword"          
          :loading="uploadingFile"
          @change="onFileChanged($event,'cvFileId','cv')"
          :error-messages="cvErrors"
        />
        <v-text-field
          v-else
          clear-icon="mdi-trash-can-outline"
          append-outer-icon="mdi-open-in-new"
          @click:clear="onFileCleared('cvFileId','cv')"
          @click:append-outer="onFileOpen('cv')"
          :value="cvFileName"          
          readonly
          clearable
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import submissionMixin from "../mixins/submission.mixin";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Resume",
  data() {
    return {};
  },
  created() {

  },
  computed: {
    ...mapFields("profile", {
      profile: "profile",
      cv: "profile.cv",
      cvFileId: "profile.cvFileId",
      cvFileName: "profile.cv.originalName"
    }),
    cvErrors() {
      const errors = [];
      if (!this.$v.cvFileName.$dirty) return errors;
      !this.$v.cvFileName.required &&
        errors.push("Your CV/Resume file is required");
      return errors;
    },
  },
  validations: {
    cvFileName: {
      required
    }
  },
  mixins: [submissionMixin],
  methods: {
    validateForm() {
      // perform form validation
      this.$v.$touch();

      // return validation result (true/false)
      return !this.$v.$invalid;      
    }
  }
};
</script>